(function () {
  'use strict';

  var sticky = document.getElementById('StickyCta');
  if (!sticky) return;

  var hero = document.querySelector('.spyr-hero');
  if (!hero) {
    // No hero on the page (e.g. non-index template) — keep hidden
    return;
  }

  // Reveal sticky CTA whenever the hero is fully out of view (header CTA is gone)
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      } else {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

  observer.observe(hero);

  // Return to top
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sticky-top]')) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
})();
